import CheckBox from '../Reusable/Form/CheckBox';
import ComboboxInput from '../Reusable/Form/ComboboxInput';
import APIS from '../../constant/EndPoint';
import { classNames } from '../../utils/classNames';
import DateRangePicker from '../Reusable/DateRrangePicker';
import useGetHook from '../../customHooks/useGetHook';
import Select, { } from 'react-select'
import makeAnimated from 'react-select/animated';
import { useEffect } from 'react';
const animatedComponents = makeAnimated();
const OrderFilter = (props: any) => {
  const { register, errors, setValue, getValues, reset, watch, clearErrors, defaultValue, setDefaultValue } = props

  const { data: statusList, } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {},
  });

  const onChange = (value: any) => {
    setValue("delivery_status__in", value)
    setDefaultValue(value)
  };

  useEffect(() => {
    if (!defaultValue) {
      setDefaultValue(watch("delivery_status__in"))
    }
  }, [watch("status")])

  return (
    <div className={classNames(props?.isFilterVisible ? "block" : "hidden", "relative")}>
      <div className={"grid grid-cols-1 md:grid-cols-3 gap-x-4 mx-4"}>
        <CheckBox
          label={"RTV Order"}
          register={register("is_rtv")}
          errors={errors?.reverse_order}
        />
        <CheckBox
          label={"Order With Remark"}
          register={register("order_remarks__isnull")}
          errors={errors?.order_remarks__isnull}
        />
        <CheckBox
          label={"Walking Customer"}
          register={register("is_walking_customer")}
          errors={errors?.walking_customer}
        />
        <div className='mt-3'>
          <label htmlFor="" className='block mb-3'>Status</label>
          <Select
            value={defaultValue}
            components={animatedComponents}
            closeMenuOnSelect={false}
            options={statusList}
            onChange={onChange}
            isMulti
          />
        </div>

        <ComboboxInput
          url={APIS.BRANCH}
          queryKey={"barnch"}
          register={register("pickup_branch")}
          errors={errors?.pickup_branch}
          name={"pickup_branch"}
          label={"Pickup Branch"}
          setValue={setValue}
          placeholder={"Select Pickup Branch"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.BRANCH}
          queryKey={"barnch"}
          register={register("destination_branch")}
          errors={errors?.destination_branch}
          name={"destination_branch"}
          label={"Select Destination Branch"}
          setValue={setValue}
          placeholder={"Select Destination Branch"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.WAREHOUSE}
          queryKey={"warehouse"}
          register={register("pickup_branch__warehouse")}
          errors={errors?.pickup_branch__warehouse}
          name={"pickup_branch__warehouse"}
          label={"Origin Warehouse"}
          setValue={setValue}
          placeholder={"Select Origin Warehouse"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.WAREHOUSE}
          queryKey={"warehouse"}
          register={register("destination_branch__warehouse")}
          errors={errors?.destination_branch__warehouse}
          name={"destination_branch__warehouse"}
          label={"Destination Warehouse"}
          setValue={setValue}
          placeholder={"Select Destination Warehouse"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.MERCHANT}
          queryKey={"merchant"}
          register={register("vendor")}
          errors={errors?.vendor}
          name={"vendor"}
          label={"Vendor"}
          setValue={setValue}
          placeholder={"Select Vendor"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <DateRangePicker
          label={"Select Date Range"}
          setValue={setValue}
          name={"created__range"}
          getValues={getValues}
        />

        <ComboboxInput
          url={APIS.CUSTOMER}
          queryKey={"customer"}
          register={register("receiver_contact")}
          errors={errors?.receiver_contact}
          name={"receiver_contact"}
          label={"Customer"}
          setValue={setValue}
          placeholder={"Select Customer"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.RIDER}
          queryKey={"rider"}
          register={register("assign_order")}
          errors={errors?.assign_order}
          name={"assign_order"}
          label={"Rider"}
          setValue={setValue}
          placeholder={"Select Rider"}
          getValues={getValues}
          clearErrors={clearErrors}
        />

      </div>
      <button className='absolute -top-5 right-5' onClick={() => reset()}>
        Reset
      </button>
    </div>

  )
}

export default OrderFilter
